(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('TriagemController', TriagemController);

  TriagemController.$inject = ['$http', '$state', 'FoundationApi', '$rootScope', 'NotificationFactory', 'CompanyService'];

  function TriagemController ($http, $state, FoundationApi, $rootScope, NotificationFactory, CompanyService) {
    var vm = this;

    vm.save = save;
    vm.changeRemoveAttendance = changeRemoveAttendance;

    var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vm.metadata = data;

        if (typeof vm.metadata.auto_dist !== 'undefined' && typeof vm.metadata.auto_dist.operator_waiting_response.change_status === 'undefined') {
          vm.metadata.auto_dist.operator_waiting_response.change_status = (!vm.metadata.auto_dist.operator_waiting_response.status || parseInt(vm.metadata.auto_dist.operator_waiting_response.status, 10) == 0) ? 0 : 1;
        }
      }).catch(function (data) {
        errorHandler(data, $rootScope.labels.errorLoadScreeModes)
      })

    function errorHandler (data, message) {
      var message = $rootScope.labels.errorTryAgain;
      if (data) {
        if (data.data) {
          if (data.data.message) { message = data.data.message; }
        }
      }
      notifSet.addNotification({
        title: $rootScope.labels.error,
        content: message,
        autoclose: '3000',
        color: 'alert'
      });
    }

    function warningHandler (data, message) {
      if (data) {
        if (data.data) {
          if (data.data.message) { message = data.data.message; }
        }
      }
      notifSet.addNotification({
        title: $rootScope.labels.error,
        content: message,
        autoclose: '3000',
        color: 'warning'
      });
    }

    function save (auto) {
      if ($rootScope.auto_dist && $rootScope.auto_dist.enabled) {
        warningHandler(null, $rootScope.labels.cannotChangeDist)
        $state.reload();
        return false
      }
      CompanyService
        .saveMetadata(vm.metadata)
        .$promise
        .then(function (data) {
          vm.metadata = data;
          if (auto) {
            notifSet.addNotification({
              title: 'Sucesso!',
              content: 'Configuração salva com sucesso!',
              autoclose: '3000',
              color: 'success'
            });
          } else {
            notifSet.addNotification({
              title: $rootScope.labels.success,
              content: $rootScope.labels.sucAlterScreening,
              autoclose: '3000',
              color: 'success'
            });
            $state.reload();
          }
        }).catch(function (data) {
          errorHandler(data, $rootScope.labels.errorSaveScreening)
        })
    }

    function changeRemoveAttendance () {
      if (vm.metadata.auto_dist.remove_chats_offline && !vm.metadata.auto_dist.hasOwnProperty('remove_chats_offline_option')) {
        vm.metadata.auto_dist['remove_chats_offline_option'] = 1
      }
    }
  }
})();
